export const DELETE_PROFILE = 'delete_profile';
export const LOAD_PROFILE = 'load_profile_details';
export const LOAD_PROFILES = 'load_profiles';
export const LOAD_PROFILE_TYPES = 'load_profile_types';
export const PROFILES_LOADED = 'set_loaded_profiles';
export const PROFILE_DELETED = 'remove_deleted_profile';
export const PROFILE_LOADED = 'set_loaded_profile';
export const PROFILE_SAVED = 'profile_has_been_saved';
export const PROFILE_TYPES_LOADED = 'set_loaded_profile_types';
export const RESET_PROFILES = 'reset_profiles';
export const RESET_SELECTED_PROFILE = 'reset_selected_profile';
export const SAVE_PROFILE = 'save_profile';
export const SYNC_FAILED = 'profiles_sync_has_failed';
